/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleempathyweak3Inputs */



/**
* | output |
* | --- |
* | "Recognising other people's feelings can be tricky for you — paying close attention to their words and reactions will help you develop empathy." |
*
* @param {Eisubscaleempathyweak3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleempathyweak3 = /** @type {((inputs?: Eisubscaleempathyweak3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleempathyweak3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recognising other people's feelings can be tricky for you — paying close attention to their words and reactions will help you develop empathy.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces no te resulta fácil reconocer los sentimientos de los demás — prestar atención a sus palabras y reacciones te ayudará a desarrollar la empatía.")
	return /** @type {LocalizedString} */ ("Тебе бывает непросто распознавать чувства других людей — внимательное отношение к их словам и реакциям поможет развить эмпатию.")
});
export { eisubscaleempathyweak3 as "eiSubscaleEmpathyWeak" }